module.exports = __webpack_public_path__ + "img/kiss-garage.c6d77761.png";